import { useFrame } from "@react-three/fiber";
import { useRef } from "react";
import { ghostValues } from "./ghost";
import { isChassisObject } from "./Chassis";
const FADE_MS = 220;
const asMesh = (object) => {
  const mesh = object;
  return mesh.isMesh ? mesh : void 0;
};
const asMaterial = (material) => Array.isArray(material) ? material[0] : material;
const hasChassisAncestor = (object) => {
  let current = object;
  while (current) {
    if (isChassisObject(current.userData)) return true;
    current = current.parent;
  }
  return false;
};
const stashOf = (mesh) => {
  var _a, _b;
  const existing = mesh.userData.solid;
  if (existing) return { solid: existing };
  const material = asMaterial(mesh.material);
  const solid = {
    transparent: (_a = material == null ? void 0 : material.transparent) != null ? _a : false,
    opacity: material && "opacity" in material ? material.opacity : 1,
    depthWrite: (_b = material == null ? void 0 : material.depthWrite) != null ? _b : true,
    castShadow: mesh.castShadow
  };
  mesh.userData.solid = solid;
  return { solid };
};
function Bodywork({ children, ghosted }) {
  const group = useRef(null);
  const amount = useRef(ghosted ? 1 : 0);
  const target = useRef(ghosted ? 1 : 0);
  target.current = ghosted ? 1 : 0;
  useFrame((_, delta) => {
    var _a;
    const next = target.current;
    const previous = amount.current;
    if (previous === next && !ghosted && previous === 0) return;
    const step = delta / (FADE_MS / 1e3);
    amount.current = previous < next ? Math.min(next, previous + step) : Math.max(next, previous - step);
    (_a = group.current) == null ? void 0 : _a.traverse((object) => {
      const mesh = asMesh(object);
      if (!mesh || hasChassisAncestor(mesh)) return;
      const material = asMaterial(mesh.material);
      if (!material) return;
      const { solid } = stashOf(mesh);
      const wasTransparent = material.transparent;
      const values = ghostValues(solid, amount.current);
      material.transparent = values.transparent;
      if ("opacity" in material) material.opacity = values.opacity;
      material.depthWrite = values.depthWrite;
      mesh.castShadow = values.castShadow;
      if (wasTransparent !== values.transparent) material.needsUpdate = true;
    });
  });
  return <group ref={group}>{children}</group>;
}
export {
  Bodywork
};
